"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var i18next_1 = tslib_1.__importDefault(require("i18next"));
var i18next_xhr_backend_1 = tslib_1.__importDefault(require("i18next-xhr-backend"));
function i18n(_a) {
    var locale = _a.locale, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
    var i18nextInstance = i18next_1.default.createInstance();
    return i18nextInstance.use(i18next_xhr_backend_1.default).init({
        lng: locale,
        fallbackLng: 'en',
        keySeparator: '$',
        interpolation: {
            prefix: '{',
            suffix: '}',
            escapeValue: false,
        },
        backend: {
            loadPath: baseUrl + "assets/locale/messages_{lng}.json",
            crossDomain: true,
        },
    });
}
exports.default = i18n;
//# sourceMappingURL=i18n.js.map